import { render, staticRenderFns } from "./social-contacts.vue?vue&type=template&id=60598ca9&"
import script from "./social-contacts.vue?vue&type=script&lang=ts&"
export * from "./social-contacts.vue?vue&type=script&lang=ts&"
import style0 from "./social-contacts.vue?vue&type=style&index=0&id=60598ca9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports